import { Weather, Forecast } from '../classes/weather';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, shareReplay, catchError } from 'rxjs/operators';
import { DOMParser } from 'xmldom';

@Injectable({ providedIn: 'root' })
export class WeatherServiceYrno {
    constructor(private http: HttpClient) {}
    /*
        getCurrentTemperaturWeatherPromise(
            locationString: string,
            locationiD: string
        ) {
            const weather = new Weather();
            const promise = new Promise<Weather>((resolve, reject) => {
                // First, start with a particular time
                const date = new Date();
    
                // Add two hours
                date.setHours(date.getHours() - 1);
                let url = '';
                if(locationiD !== undefined && locationiD.length > 0)
                {
                    url = 'http://opendata.fmi.fi/wfs/fin?service=WFS&version=2.0.0&request=getFeature&storedquery_id=fmi::observations::weather::timevaluepair&fmisid=' +
                                locationiD;
                }
                else
                {
                    url = 'http://opendata.fmi.fi/wfs/fin?service=WFS&version=2.0.0&request=getFeature&storedquery_id=fmi::observations::weather::timevaluepair&place=' +
                            locationString
                }
                this.http
                    .get(
                        url +
                        '&parameters=t2m&starttime=' +
                        date.toISOString(),
                        { responseType: 'text' }
                    )
                    .toPromise()
                    .then(response => {
                        this.handleTemperatureResponse(response, weather);
                        resolve(weather);
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
    
            return promise;
        }
    */
    getForecastYrno$(locationString: string, locationYrno: string): Observable<Forecast[]> {
        const date = new Date();
        date.setHours(date.getHours() + 30);

/*
            const header = new HttpHeaders();
            header.set('Access-Control-Allow-Origin', 'www.saatanaan.fi');
            header.set('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,OPTIONS');
            header.set('Access-Control-Allow-Headers', '*');
            header.set('Access-Control-Expose-Headers', '*');*/


    return this.http
      .get('https://api.met.no/weatherapi/locationforecast/2.0/classic?' + locationYrno, { responseType: 'text' })
      .pipe(
        map(response => {
          const forecast: Forecast[] = [];
          this.handleForecastResponseYrno(response, forecast);
          return forecast;
        }),
        shareReplay(1),
        catchError(err => throwError(err))
      );
  }

 
    private handleForecastResponseYrno(response: string, forecast: Forecast[]) {
        const xmlDoc = new DOMParser().parseFromString(response, 'text/xml');

        const timeSeriesElements = xmlDoc.getElementsByTagName('time');



        for (let i = 0; i < timeSeriesElements.length; i++) {
            const item = timeSeriesElements.item(i);
            if (!item) {
                continue;
            }

            if (item.getAttribute && item.getAttribute('from') != null && item.getAttribute('from').toString() !== '' &&
                (item.getAttribute('to') != null && item.getAttribute('to').toString() !== '')) {
                //console.log(item.getAttribute('from').toString());

                var itemtimeDateFrom = new Date(item.getAttribute('from'));
                var itemtimeDateTo = new Date(item.getAttribute('to'));

                const diffMsFromTo = (itemtimeDateTo.getTime() - itemtimeDateFrom.getTime()); // milliseconds
                var diffMinsFromTo = Math.round(diffMsFromTo  / 60000); // minutes
                if(diffMinsFromTo > 60)
                    continue;

                const currentDate = new Date();
                const diffMs = (itemtimeDateFrom.getTime() - currentDate.getTime()); // milliseconds
                var diffMins = Math.round(diffMs / 60000); // minutes
                var diffHrs = Math.round(diffMins / 60); // hours
                //console.log('diffHrs:'+diffHrs);
                if (diffHrs > 30) {
                    continue;
                }



                var itemtime = itemtimeDateFrom.toString();

                const result = forecast.find(obj => {
                    return (
                        obj.Time.getTime() ===
                        new Date(
                            itemtime
                        ).getTime()
                    );
                });

                if (
                    result != null &&
                    result !== undefined 
                ) {
                    if (item.getElementsByTagName('precipitation') != null &&
                        item.getElementsByTagName('precipitation')[0] != null &&
                        item.getElementsByTagName('precipitation')[0].getAttribute('value') != null
                    ) {
                        result.Precipitation = item.getElementsByTagName('precipitation')[0].getAttribute('value');
                    }
                    
                    if (item.getElementsByTagName('temperature') != null &&
                        item.getElementsByTagName('temperature')[0] != null &&
                        item.getElementsByTagName('temperature')[0].getAttribute('value') != null) {
                        result.Temperature = item.getElementsByTagName('temperature')[0].getAttribute('value');
                    }
                    
                    if (item.getElementsByTagName('windSpeed') != null &&
                    item.getElementsByTagName('windSpeed')[0] != null &&
                    item.getElementsByTagName('windSpeed')[0].getAttribute('mps') != null)
                    {
                        result.WindSpeed = Math.round(item.getElementsByTagName('windSpeed')[0].getAttribute('mps')).toString();

                    }

                    if (item.getElementsByTagName('symbol') != null &&
                    item.getElementsByTagName('symbol')[0] != null &&
                    item.getElementsByTagName('symbol')[0].getAttribute('number') != null)
                    {
                        result.WeatherState = item.getElementsByTagName('symbol')[0].getAttribute('number');
                        result.WeatherSymbolUrl = this.getWeatherSymbolYrno(result.WeatherState );
                        
                    }

                } else {
                    const forecastTemp = new Forecast();
                    forecastTemp.Time = new Date(
                        itemtime.toString()
                    );

                    if (item.getElementsByTagName('precipitation') != null &&
                        item.getElementsByTagName('precipitation')[0] != null &&
                        item.getElementsByTagName('precipitation')[0].getAttribute('value') != null) {
                        forecastTemp.Precipitation = item.getElementsByTagName('precipitation')[0].getAttribute('value');
                    }
                    
                    if (item.getElementsByTagName('temperature') != null &&
                        item.getElementsByTagName('temperature')[0] != null &&
                        item.getElementsByTagName('temperature')[0].getAttribute('value') != null) {
                        forecastTemp.Temperature = item.getElementsByTagName('temperature')[0].getAttribute('value');
                    }
                    
                    if (item.getElementsByTagName('windSpeed') != null &&
                    item.getElementsByTagName('windSpeed')[0] != null &&
                    item.getElementsByTagName('windSpeed')[0].getAttribute('mps') != null)
                    {
                        forecastTemp.WindSpeed = Math.round(item.getElementsByTagName('windSpeed')[0].getAttribute('mps')).toString();

                    }

                    if (item.getElementsByTagName('symbol') != null &&
                    item.getElementsByTagName('symbol')[0] != null &&
                    item.getElementsByTagName('symbol')[0].getAttribute('number') != null)
                    {
                        forecastTemp.WeatherState = item.getElementsByTagName('symbol')[0].getAttribute('number');
                        forecastTemp.WeatherSymbolUrl =  this.getWeatherSymbolYrno(forecastTemp.WeatherState);

                    }
                    //forecastTemp.Temperature = item.getElementsByTagName('temperature')[0].getAttribute('value');
                    //forecastTemp.Precipitation = item.getElementsByTagName('precipitation')[0].getAttribute('value');
                    //forecastTemp.WeatherState = item.getElementsByTagName('symbol')[0].getAttribute('var');
                    /*forecastTemp.WeatherSymbolUrl = this.getWeatherSymbolYrno(
                        item.getElementsByTagName('symbol')[0].getAttribute('var')
                    );*/

                    if (forecast == null || forecast === undefined) {
                        forecast = [];
                    }

                    forecast.push(forecastTemp);
                }
            }


        }
    }

    private handleForecastResponse(response: string, forecast: Forecast[]) {
        const xmlDoc = new DOMParser().parseFromString(response, 'text/xml');

        const timeSeriesElements = xmlDoc.getElementsByTagName('time');


        for (let i = 0; i < timeSeriesElements.length; i++) {
            const item = timeSeriesElements.item(i);
            if (!item) {
                continue;
            }

            // safe access for temperature element
            const tempEl = item.getElementsByTagName('temperature')[0];
            if (tempEl && tempEl.textContent) {
                console.log(tempEl.textContent);
            }


            /*
                        if (item.hasAttribute('gml:id')) {
                            if (
                                item.getAttribute('gml:id').toString() === 'mts-1-1-WeatherSymbol3'
                            ) {
                                const elements = xmlDoc.getElementsByTagName('wml2:MeasurementTVP');
            
            
                                for (const elementItem of elements) {
                                    if (
                                        elementItem.getElementsByTagName('wml2:time')[0] !== null &&
                                        elementItem.getElementsByTagName('wml2:value')[0] !== null
                                    ) {
                                        if (
                                            forecast != null &&
                                            forecast !== undefined &&
                                            forecast.hasOwnProperty(
                                                elementItem.getElementsByTagName('wml2:time')[0].textContent
                                            )
                                        ) {
                                            // tslint:disable-next-line: no-string-literal
                                            forecast['Time'].WeatherState = elementItem.getElementsByTagName('wml2:value')[0].textContent;
                                            // tslint:disable-next-line: no-string-literal
                                            forecast['Time'].WeatherSymbolUrl = this.getWeatherSymbol(elementItem.getElementsByTagName('wml2:value')[0].textContent);
            
                                        } else {
                                            const forecastTemp = new Forecast();
                                            forecastTemp.Time = new Date(
                                                elementItem.getElementsByTagName('wml2:time')[0].textContent
                                            );
                                            forecastTemp.WeatherState = elementItem.getElementsByTagName(
                                                'wml2:value'
                                            )[0].textContent;
                                            forecastTemp.WeatherSymbolUrl = this.getWeatherSymbol(
                                                elementItem.getElementsByTagName('wml2:value')[0].textContent
                                            );
            
                                            if (forecast == null || forecast === undefined) {
                                                forecast = [];
                                            }
            
                                            forecast.push(forecastTemp);
                                        }
                                    }
                                }
                            } else if (
                                item.getAttribute('gml:id').toString() === 'mts-1-1-temperature'
                            ) {
                                const elements = xmlDoc.getElementsByTagName('wml2:MeasurementTVP');
            
                                for (const elementItem of elements) {
                                    if (
                                        elementItem.getElementsByTagName('wml2:time')[0] !== null &&
                                        elementItem.getElementsByTagName('wml2:value')[0] !== null
                                    ) {
                                        const result = forecast.find(obj => {
                                            return (
                                                obj.Time.getTime() ===
                                                new Date(
                                                    elementItem.getElementsByTagName('wml2:time')[0].textContent
                                                ).getTime()
                                            );
                                        });
            
                                        if (result !== undefined) {
                                            result.Temperature = elementItem.getElementsByTagName(
                                                'wml2:value'
                                            )[0].textContent;
                                        } else {
                                            const forecastTemp = new Forecast();
                                            forecastTemp.Time = new Date(
                                                elementItem.getElementsByTagName('wml2:time')[0].textContent
                                            );
                                            forecastTemp.Temperature = elementItem.getElementsByTagName(
                                                'wml2:value'
                                            )[0].textContent;
            
                                            if (forecast == null || forecast === undefined) {
                                                forecast = [];
                                            }
            
                                            forecast.push(forecastTemp);
                                        }
                                    }
                                }
                            }
                        }*/
        }
    }


    getWeatherSymbolYrno(weatherState: string): string {

        return '/assets/yrnosymbols/' + weatherState.toString() + '.svg';
    }


    /*

  function handleResponse(response) {
          var xmlDoc = $.parseXML(response.data);

          var elements = xmlDoc.getElementsByTagName('wml2:MeasurementTVP');
          var outputString = '0.0';
          var dict = [];

          for (var i = 0; i < elements.length; i++) {
              if (elements.item(i).getElementsByTagName('wml2:time')[0] !== null &&
                  elements.item(i).getElementsByTagName('wml2:value')[0] !== null) {

                  dict.push({
                      key: elements.item(i).getElementsByTagName('wml2:time')[0].textContent,
                      value: elements.item(i).getElementsByTagName('wml2:value')[0].textContent
                  });
              }
          }

         if (dict.length > 0) {
          outputString = dict[dict.length-1].value; // Viimeinen arvo on uusin arvo
          //console.log('Temperature:' + outputString);
      }

      return outputString;

  }


    function getWeather($http, locationiD, locationString) {
      let weather = {
          Temperature: '',
          WeatherState: '',
          WeatherSymbolUrl: '',
          Forecast: [] /*{
              Time: '',
          Weather: [{
              Temperature: '',
              WeatherState: '',
              WeatherSymbol: ''

      }

      $http.get('http://opendata.fmi.fi/wfs/fin?service=WFS&version=2.0.0&request=getFeature&storedquery_id=fmi::observations::weather::timevaluepair&fmisid='+locationiD+'&parameters=t2m&', {
          method: 'GET'
      })
          .then(function (response) {
              weather.Temperature = handleResponse(response);
          })
          .catch(function (data) {

          });


      $http.get('http://opendata.fmi.fi/wfs/fin?service=WFS&version=2.0.0&request=getFeature&storedquery_id=fmi::forecast::hirlam::surface::point::timevaluepair&place=' + locationString+'&parameters=WeatherSymbol3,temperature', {
          method: 'GET'
      })
          .then(function (response) {
              weather.WeatherState = handleWeatherResponse(response, weather.Forecast);
              weather.WeatherSymbolUrl = getWeatherSymbol(weather.WeatherState);
          })
          .catch(function (data) {

          });


      return weather;
  }
  */
}
